<mobile-navbar
  [title]="'Planner'"
  (onLeftButtonClick)="onHamburgerClick.emit()"
></mobile-navbar>
<div class="overflow-y-scroll h-full pb-32 pt-[var(--mobile-navbar-height)]">
  <welcome-to-the-planner
    *ngIf="detailedTags.length === 0 && detailedArchivedTags.length === 0"
    (addTag)="openCreateTagBottomSheetOrUpsell()"
  ></welcome-to-the-planner>

  <!-- Fixed -->
  <div class="p-4" *ngIf="getFixedTags().length > 0">
    <h2 class="font-bold text-lg">Fixed tags</h2>
    <p>Fixed tags have fixed summaries</p>
  </div>
  <mat-list role="list">
    <div
      *ngFor="let tag of getFixedTags(); trackBy: trackByTagId"
      class="flex items-center border-b"
    >
      <mat-list-item
        role="listitem"
        [lines]="1"
        (click)="openEditTagBottomSheet(tag)"
      >
        <div matListItemTitle>
          <span
            class="tag {{
              getTopLevelTag(tag, detailedTags)?.color
            }} text-black"
            >#{{ tag.fullPath }}</span
          >
        </div>
      </mat-list-item>
      <div class="w-[100px] flex justify-end pr-2">
        <span (click)="move(tag, 'up')"
          ><mat-icon class="align-middle mr-4 text-gray-400"
            >arrow_upward</mat-icon
          ></span
        >
        <span (click)="move(tag, 'down')"
          ><mat-icon class="align-middle text-gray-400"
            >arrow_downward</mat-icon
          ></span
        >
      </div>
    </div>
  </mat-list>

  <!-- Periodic -->
  <div class="p-4" *ngIf="getPeriodicTags().length > 0">
    <h2 class="font-bold text-lg">Periodic tags</h2>
    <p>Periodic tags have periodic summaries</p>
  </div>
  <mat-list role="list">
    <div
      *ngFor="let tag of getPeriodicTags(); trackBy: trackByTagId"
      class="flex items-center border-b"
    >
      <mat-list-item
        role="listitem"
        [lines]="1"
        (click)="openEditTagBottomSheet(tag)"
      >
        <div matListItemTitle>
          <span
            class="tag {{
              getTopLevelTag(tag, detailedTags)?.color
            }} text-black"
            >#{{ tag.fullPath }}</span
          >
        </div>
      </mat-list-item>
      <div class="w-[100px] flex justify-end pr-2">
        <span (click)="move(tag, 'up')"
          ><mat-icon class="align-middle mr-4 text-gray-400"
            >arrow_upward</mat-icon
          ></span
        >
        <span (click)="move(tag, 'down')"
          ><mat-icon class="align-middle text-gray-400"
            >arrow_downward</mat-icon
          ></span
        >
      </div>
    </div>
  </mat-list>

  <!-- Archived -->
  <div class="p-4" *ngIf="hasArchivedTags()">
    <h2 class="font-bold text-lg">Archived tags</h2>
    <p>Archived tags are hidden from sidebar and autocomplete.</p>
  </div>
  <mat-list role="list" *ngIf="hasArchivedTags()">
    <div
      *ngFor="let tag of detailedArchivedTags; trackBy: trackByTagId"
      class="flex items-center border-b"
    >
      <mat-list-item
        role="listitem"
        [lines]="1"
        (click)="openEditTagBottomSheet(tag)"
      >
        <div matListItemTitle>
          <span class="tag archived {{ getColor(tag) }} text-black"
            >#{{ tag.fullPath }}</span
          >
        </div>

        <!-- </div> -->
      </mat-list-item>
    </div>
  </mat-list>
</div>

<button
  class="!fixed bottom-4 right-4"
  mat-fab
  matTooltip="New tag"
  (click)="openCreateTagBottomSheetOrUpsell()"
>
  <mat-icon>add</mat-icon>
</button>
